import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import TurnstileState from '../common/states/TurnstileState';
import Turnstile from './components/Turnstile';
export default function extendAuthModalsWithTurnstile() {
  const isEnabled = type => !!app.forum.attribute(`flectar-turnstile.${type}`);
  const applyExtenders = (modulePath, type, dataMethod) => {
    extend(modulePath, 'oninit', function () {
      if (!isEnabled(type)) return;
      let turnstileAlert = null;
      this.turnstile = new TurnstileState(() => {
        if (turnstileAlert && this.alertAttrs === turnstileAlert) {
          this.alertAttrs = null;
          m.redraw();
        }
        turnstileAlert = null;
      }, alertAttrs => {
        // Widget failures must not finish pending requests or reset the challenge.
        this.alertAttrs = turnstileAlert = alertAttrs;
        m.redraw();
      });
    });
    extend(modulePath, dataMethod, function (data) {
      if (!isEnabled(type)) return;
      data.turnstileToken = this.turnstile.getResponse();
    });
    extend(modulePath, 'fields', function (items) {
      if (!isEnabled(type)) return;
      const priority = modulePath.includes('ChangePasswordModal') ? 10 : -5;
      items.add('turnstile', m(Turnstile, {
        state: this.turnstile
      }), priority);
    });
    extend(modulePath, 'onerror', function (_, error) {
      if (!isEnabled(type)) return;
      const requestError = error;
      this.turnstile.reset();
      if (requestError.alert && !requestError.alert.content?.length) {
        requestError.alert.content = app.translator.trans('flectar-turnstile.forum.validation_error');
      }
    });
  };
  applyExtenders('flarum/forum/components/ForgotPasswordModal', 'forgot', 'requestParams');
  applyExtenders('flarum/forum/components/LogInModal', 'signin', 'loginParams');
  applyExtenders('flarum/forum/components/SignUpModal', 'signup', 'submitData');
  applyExtenders('flarum/forum/components/ChangePasswordModal', 'forgot', 'requestBody');
  extend('flarum/forum/components/ChangePasswordModal', 'loaded', function () {
    if (isEnabled('forgot')) this.turnstile.reset();
  });
}